import { render, staticRenderFns } from "./AddYourPhoneNumber.vue?vue&type=template&id=6d7a2c7c&scoped=true&"
import script from "./AddYourPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./AddYourPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./AddYourPhoneNumber.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddYourPhoneNumber.vue?vue&type=style&index=1&id=6d7a2c7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a2c7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
